import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const List = props => {
  const wrappedChildren = React.Children.map(props.children, (item, i) => (
    <li className='list-item ' key={i}>
      {item}
    </li>
  ))
  return (
    <ul
      className={classNames({
        list: true,
        [props.className]: props.className
      })}
    >
      {wrappedChildren}
    </ul>
  )
}

List.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.string)
}

export default List



// WEBPACK FOOTER //
// ./src/ui/utilities/list.js